import { trim } from 'ramda';

import { useAppDispatch } from '@/shared/hooks';

import { reportsModel } from '@/entities/reports';
import { toothModel } from '@/entities/tooth';

export const useAddNewComment = () => {
  const dispatch = useAppDispatch();

  return async (toothID: string, newComment: string) => {
    dispatch(
      toothModel.actions.setNewCommentOptimistic({
        toothID,
        comment: newComment,
      }),
    );

    // Note: Mark as user-saved comment
    if (trim(newComment)) {
      dispatch(toothModel.actions.markToothCommentAsUserSaved(toothID));
    } else {
      // Note: If comment is empty, clear the user-saved flag
      dispatch(toothModel.actions.clearUserSavedToothComment(toothID));
    }

    await dispatch(
      reportsModel.thunks.setReportToothComment({
        ToothID: toothID,
        Comment: trim(newComment),
      }),
    );
  };
};
